import * as React from 'react';

function SvgSticky(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M2.5 1A1.5 1.5 0 001 2.5v11A1.5 1.5 0 002.5 15h6.086a1.5 1.5 0 001.06-.44l4.915-4.914A1.5 1.5 0 0015 8.586V2.5A1.5 1.5 0 0013.5 1h-11zM2 2.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5V8H9.5A1.5 1.5 0 008 9.5V14H2.5a.5.5 0 01-.5-.5v-11zm7 11.293V9.5a.5.5 0 01.5-.5h4.293L9 13.793z' />
		</svg>
	);
}

export default SvgSticky;
